import { SlotProps, TooltipArrowSlotPropsOverrides, TooltipOwnerState } from '@mui/material';

export const RIGHT_ARROW_PROPS: SlotProps<'span', TooltipArrowSlotPropsOverrides, TooltipOwnerState> = {
  sx: {
    left: 'calc(100% - 16px) !important',
    transform: 'translate(-50%, 0px) !important',
  },
};
